"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _objectWithoutProperties = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["smoothing"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visualizeAudio = void 0;

var get_visualization_1 = require("./fft/get-visualization");

var max_value_cached_1 = require("./fft/max-value-cached");

var cache = {};

var visualizeAudioFrame = function visualizeAudioFrame(_ref) {
  var metadata = _ref.audioData,
      frame = _ref.frame,
      fps = _ref.fps,
      numberOfSamples = _ref.numberOfSamples;
  var cacheKey = metadata.resultId + frame + fps + numberOfSamples;

  if (cache[cacheKey]) {
    return cache[cacheKey];
  }

  var maxInt = (0, max_value_cached_1.getMaxPossibleMagnitude)(metadata);
  return (0, get_visualization_1.getVisualization)({
    sampleSize: numberOfSamples * 2,
    data: metadata.channelWaveforms[0],
    frame: frame,
    fps: fps,
    sampleRate: metadata.sampleRate,
    maxInt: maxInt
  });
};

var visualizeAudio = function visualizeAudio(_ref2) {
  var _ref2$smoothing = _ref2.smoothing,
      smoothing = _ref2$smoothing === void 0 ? true : _ref2$smoothing,
      parameters = _objectWithoutProperties(_ref2, _excluded);

  if (!smoothing) {
    return visualizeAudioFrame(parameters);
  }

  var toSmooth = [parameters.frame - 1, parameters.frame, parameters.frame + 1];
  var all = toSmooth.map(function (s) {
    return visualizeAudioFrame(_objectSpread(_objectSpread({}, parameters), {}, {
      frame: s
    }));
  });
  return new Array(parameters.numberOfSamples).fill(true).map(function (_x, i) {
    return new Array(toSmooth.length).fill(true).map(function (_, j) {
      return all[j][i];
    }).reduce(function (a, b) {
      return a + b;
    }, 0) / toSmooth.length;
  });
};

exports.visualizeAudio = visualizeAudio;